export default "__VITE_ASSET__D$UMKPPj__";